import type React from "react";

import { Tooltip as MUITooltip } from "@mui/material";
import type { TooltipProps } from "@mui/material";
import { withStyles } from "@mui/styles";

import { theme } from "theme";

const TextOnlyTooltip = withStyles({
  arrow: {
    "&:before": {
      border: `1px solid ${theme.colors.redesign.db30}`,
    },
    color: theme.colors.white,
  },
  tooltip: {
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.redesign.db30}`,
    boxShadow: "0 0 3px 0 rgba(0, 0, 0, 0.2)",
    color: theme.colors.redesign.db100,
    fontSize: "14px",
    lineHeight: "20px",
    whiteSpace: "pre-wrap",
  },
})(MUITooltip);

interface Props extends TooltipProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: React.ReactElement<any, any>;
  disabled?: boolean;
  title: NonNullable<React.ReactNode>;
}

export const Tooltip: React.FC<Props> = ({ children, disabled, title, ...props }) => {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <TextOnlyTooltip title={title} {...props}>
      <div>{children}</div>
    </TextOnlyTooltip>
  );
};
